import { lazy, Suspense } from "react";
import Layout from "./Layout";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

const Withdrow = lazy(() => import("./ui/views/Withdrow/Index"))
const KishPortInfo = lazy(() => import("./ui/views/kishPortInfo/Index"));
const Profile = lazy(() => import("./ui/views/Profile/Index"));
const ListItems = lazy(() => import("./ui/views/AmusementGroup/Index"));
const IndexAmusementDetail = lazy(() => import("./ui/views/AmusementDetail/Index"));
const MyOrder = lazy(() => import("./ui/views/UserOrder/Index"));
const OrderDetail = lazy(() => import("./ui/views/UserOrder/OrderDetail"));
const TransactionList = lazy(() => import("./ui/views/Transaction/Index"));
const WalletUser = lazy(() => import("./ui/views/Wallet/Index"));
const Ticket = lazy(() => import("./ui/views/UserOrder/Component/Ticket"));
const HomeContent = lazy(() => import("./ui/views/Home/Index"));
const Refund = lazy(() => import("./ui/views/Refund/Index"));
const LoginRegister = lazy(() => import("./ui/components/Login/LoginRegister"));
const Payment = lazy(() => import("./ui/views/Payment/Index"));
const SearchPage = lazy(() => import("./ui/views/_layout/Search"));
const ContactUs = lazy(() => import("./ui/views/ContactUs/Index"));
const Weather = lazy(() => import("./ui/views/Weather/Index"));
const PageNotFound = lazy(() => import("./ui/components/PageNotFound"));
const AfterPayIndex = lazy(() => import("./ui/views/AfterPay/AfterPayIndex"));
const AmusementComplex = lazy(() => import("./ui/views/AmusementComplex/Index"));
const WithdrawFromWallet = lazy(() => import("./ui/views/Wallet/WithdrawFromWallet"));
const AmusementPackage = lazy(() => import("./ui/views/AmusementPackage/Index"));
const AboutUs = lazy(() => import("./ui/views/AboutUs/Index"));
const SiteRoles = lazy(() => import("./ui/views/SiteRoles/Index"));
const BasketContent = lazy(() => import("./ui/views/Basket/Index"));
const Concert = lazy(() => import("./ui/views/AboutUs/concert"));

function App() {
  return (
    <Router>
      <Layout>
        <Suspense fallback={null}>
          <Routes>
            {/* <Route path="/" element={<HomeContent />} /> */}
            <Route
              path="/"
              element={
                <HomeContent />
              }
            />
            <Route
              path="/details/:urlName"
              element={
                <IndexAmusementDetail />
              }
            />
            <Route
              path="/details/:urlName/pickdate"
              element={
                <IndexAmusementDetail />
              }
            />
            <Route
              path="/details/:urlName/selectname"
              element={
                <IndexAmusementDetail />
              }
            />
            <Route
              path="/details/:urlName/description"
              element={
                <IndexAmusementDetail />
              }
            />
            <Route
              path="/details/:urlName/selectplace"
              element={
                <IndexAmusementDetail />
              }
            />
            <Route
              path="/details/:urlName/importantAndNecessaryPoints"
              element={
                <IndexAmusementDetail />
              }
            />
            <Route
              path="/details/:urlName/comment"
              element={
                <IndexAmusementDetail />
              }
            />
            <Route
              path="/details/:urlName/allComments"
              element={
                <IndexAmusementDetail />
              }
            />
            {/*    <Route*/}
            {/*  path="/reserve"*/}
            {/*  element={*/}
            {/*    <>*/}
            {/*      <BeforePageRender />*/}
            {/*      <IndexAmusementDetail />*/}
            {/*    </>*/}
            {/*  }*/}
            {/*/>*/}
            <Route
              path="/basket"
              element={
                <BasketContent />
              }
            />

            <Route
              path="/order"
              element={
                <MyOrder />
              }
            />
            <Route
                  path="/concert"
                  element={
                    <>
                      <Concert />
                    </>
                  }
                />
            <Route
              path="/order/orderList"
              element={
                <MyOrder />
              }
            />
            <Route
              path="/order/orderDetail/:id"
              element={
                <OrderDetail />
              }
            />
            <Route
              path="/wallet"
              element={
                <WalletUser />
              }
            />
            <Route
              path="/withdrow"
              element={
                <Withdrow />
              }
            />
            <Route
              path="/refund"
              element={
                <Refund />
              }
            />
            <Route
              path="/withdrowFromWallet"
              element={
                <WithdrawFromWallet />
              }
            />

            <Route
              path="/aboutUs"
              element={
                <AboutUs />
              }
            />

            <Route
              path="/login"
              element={
                <LoginRegister />
              }
            />
            <Route
              path="/payment"
              element={
                <Payment />
              }
            />
            <Route
              path="/afterPay"
              element={
                <AfterPayIndex />
              }
            />
            <Route
              path="/search"
              element={
                <SearchPage />
              }
            />
            <Route
              path="/contact"
              element={
                <ContactUs />
              }
            />
            <Route
              path="/ticket/:id"
              element={
                <Ticket />
              }
            />
            <Route
              path="/weather"
              element={
                <Weather />
              }
            />
            <Route
              path="/s/kishportinfo"
              element={
                <KishPortInfo />
              }
            />
            <Route
              path="/profile"
              element={
                <Profile />
              }
            />
            <Route
              path="/transaction"
              element={
                <TransactionList />
              }
            />
            <Route
              path="/c/:urlParamCity?/:urlParamGroup?"
              element={
                <ListItems />
              }
            />
            {/* <Route
                path="/sitemap"
                element={

                  <SiteMap />

                }
              /> */}
            <Route
              path="/siteRoles"
              element={
                <SiteRoles />
              }
            />
            <Route
              path="/p/:urlName"
              element={
                <AmusementComplex />
              }
            />
            <Route
              path="/p/:urlName/comment"
              element={
                <AmusementComplex />
              }
            />
            <Route
              path="/g"
              element={
                <AmusementPackage />
              }
            />
            <Route
              path="/p/:urlName/allComments"
              element={
                <AmusementComplex />
              }
            />
            <Route
              path="*"
              status={404}
              element={
                <PageNotFound />
              }
            />
            {/* <Route path="/login" element={<LoginPage />} /> */}

            {/* <BeforePageRender pageTitle="تفریحان" /> */}
            {/* </Route> */}
            {/* ... Routeهای دیگر ... */}
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}

export default App;
